/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["space-input{display:block}space-input.input-container input{flex:1 1 auto;border-top-right-radius:0;border-bottom-right-radius:0;border-right:none}space-input.input-container select{width:80px;flex:0 0 80px;border-top-left-radius:0;border-bottom-left-radius:0}space-input .wrapper{display:flex}"];
export { styles as styles };
